module.exports = __webpack_public_path__ + "images/emoji/scroll.75616f92d80973a0951b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/scroll.png
// module id = g4wI
// module chunks = 24